import ar from './ar';
import az from './az';
import be from './be';
import bg from './bg';
import bs from './bs';
import ca from './ca';
import cs from './cs';
import cy from './cy';
import da from './da';
import de from './de';
import el from './el';
import en from './en';
import es from './es';
import et from './et';
import eu from './eu';
import fa from './fa';
import fi from './fi';
import fr from './fr';
import hr from './hr';
import hu from './hu';
import id from './id';
import it from './it';
import ja from './ja';
import ka from './ka';
import km from './km';
import ko from './ko';
import lt from './lt';
import lv from './lv';
import mk from './mk';
import mn from './mn';
import ms from './ms';
import nb_NO from './nb_NO';
import nl from './nl';
import pl from './pl';
import pt from './pt';
import pt_BR from './pt_BR';
import ro from './ro';
import ru from './ru';
import se from './se';
import sl from './sl';
import sq from './sq';
import sr from './sr';
import sv from './sv';
import tr from './tr';
import ua from './ua';
import uk from './uk';
import uz from './uz';
import vi from './vi';
import zh from './zh';
import zh_TW from './zh_TW';
export default {
    ar,
    az,
    be,
    bg,
    bs,
    ca,
    cs,
    cy,
    da,
    de,
    el,
    en,
    es,
    et,
    eu,
    fa,
    fi,
    fr,
    hr,
    hu,
    id,
    it,
    ja,
    ka,
    km,
    ko,
    lt,
    lv,
    mk,
    mn,
    ms,
    nb_NO,
    nl,
    pl,
    pt,
    pt_BR,
    ro,
    ru,
    se,
    sl,
    sq,
    sr,
    sv,
    tr,
    ua,
    uk,
    uz,
    vi,
    zh,
    zh_TW,
};
